import config from 'scoreboard/components/config'
import _ from 'lodash'

// setup as a function b/c config might not be loaded when JS is first being
// parsed
var regExp = _.memoize(function() {
	// find all undesirable characters (thousands separators and spaces)
	return new RegExp('[\\s' + config.groupingSeparator + ']', 'g')
})

function numericEvaluator(val) {
	if (_.isEmpty(val)) {
		return null
	}

	// remove all undesirable characters
	// important: must pass in config.groupingSeparator for
	// numeric-evaluator-test, or else the memoized function will have the
	// wrong grouping separator
	val = val.split(regExp(config.groupingSeparator)).join('')

	// issue 5529 handle different decimal separators
	if (config.decimalSeparator != '.') {
		val = val.replace(config.decimalSeparator, '.')
	}

	// #36118 handle different minus sign for some locales
	if (config.minusSign != '-') {
		val = val.replace(config.minusSign, '-')
	}

	return val
}

export default numericEvaluator

numericEvaluator.__filename__ = 'components/evaluators/numeric-evaluator.js'
